import { PassportsList as Data } from '@/typings/api/PassportList'
import { Model, createMessages } from '@/helpers/Model'


export class PassportsListModel extends Model<Data> {
    public static readonly page_title = createMessages({
      create: 'Добавить паспорт',
      edit: 'Редактировать паспорт',
      view: (data: PassportsListModel) => 'Паспорт «{name}»'
        .replace('{name}', data.name || '...'),
      list: 'Список паспортов',
    });
}
